import { createUseTranslation } from '@nexelem/services';
import type { TableTranslation } from './table-pl';

type TableTranslationRoot = {
  table: TableTranslation;
};

const useTranslation = createUseTranslation<TableTranslationRoot>();

export const useTableTranslation = () => {
  const { tWrapper } = useTranslation('table');

  return { t: tWrapper };
};
